import { createContext, useContext, useState } from 'react';

const PlayerContext = createContext();

export function PlayerProvider({ children }) {
  const [currentTrack, setCurrentTrack] = useState(null);
  // currentTrack shape: { url, title, artist, coverUrl } | null

  const playTrack = (track) => {
    setCurrentTrack(track);
  };

  const stopTrack = () => {
    setCurrentTrack(null);
  };

  return (
    <PlayerContext.Provider value={{ currentTrack, playTrack, stopTrack }}>
      {children}
    </PlayerContext.Provider>
  );
}

export const usePlayer = () => useContext(PlayerContext);
